import React, { useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import ReactGA from "react-ga";

ReactGA.initialize("GTM-5RK9R65");

function CopyrightInformation() {
  useEffect(() => {
    ReactGA.event({
      category: "Copyright Information",
      action: "Viewing Copyright Information",
    });
    return () => {};
  }, []);
  return (
    <>
      <Typography variant="h3" gutterBottom>
        <strong>Copyright:</strong>
      </Typography>
      <br />
      <Typography variant="subtitle1" gutterBottom>
        <strong>Web Application:</strong>
      </Typography>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Component Name</strong>
            </TableCell>
            <TableCell>
              <strong>Copyright</strong>
            </TableCell>
            <TableCell align="right">
              <strong>License Text</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              smile-test-dashboard
            </TableCell>
            <TableCell>Copyright (c) 2019 Devias</TableCell>
            <TableCell align="right">MIT</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br />
      <Typography variant="subtitle1" gutterBottom>
        <strong>Mobile Application:</strong>
      </Typography>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Component Name</strong>
            </TableCell>
            <TableCell>
              <strong>Copyright</strong>
            </TableCell>
            <TableCell align="right">
              <strong>License Text</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              conekta-react-native
            </TableCell>
            <TableCell>Copyright (c) 2015 Dieam</TableCell>
            <TableCell align="right">MIT</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              jsreport-studio
            </TableCell>
            <TableCell>Copyright (c) 2015 Erik Rasmussen</TableCell>
            <TableCell align="right">MIT</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              nest-url-mapper
            </TableCell>
            <TableCell>Copyright (c) 2020 @ummo93</TableCell>
            <TableCell align="right">MIT</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              react-native-camera-library2
            </TableCell>
            <TableCell>Copyright (c) 2015 Loch Wansbrough</TableCell>
            <TableCell align="right">MIT</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              react-native-lock
            </TableCell>
            <TableCell>Copyright (c) 2015 Auth0, Inc.</TableCell>
            <TableCell align="right">MIT</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}

export default CopyrightInformation;
